
import CustomSelect from "../Select/Select";

export default class PageSelect {
	static init() {
		Array.prototype.forEach.call(document.querySelectorAll('.page-select'), el => {
			new PageSelect(el);
		});
	}

	constructor(el) {
		let select = new CustomSelect(el);

		if(el.dataset.width) {
			// apply with to select
			select.select.setAttribute('style', 'width:' + el.dataset.width);
		}

		if(el.classList.contains('page-select--switch-on-change')) {
			select.on('change', (e) => {
				window.location = e.key;
			});
		}
	}
}
